import React from 'react';
import DimensionByYearReport from './DimensionByYearReport';

export default function CountryByYear() {
  return <DimensionByYearReport title="Sales by country" dimension="byCountry" rowLabel="Country" />;
}
